module.exports = __webpack_public_path__ + "static/img/50.4cb2f4d0.png";